<div class="relative gg">
  <div class="relative flex flex-col h-[100vh] overflow-y-scroll right-tag">
    <div class="w-full flex-grow flex items-center">
      <div class="card-holder mx-auto">
        <div class="block w-full relative p-4">
          <div class="relative land-container py-8 rounded-2xl">
            <div class="login-container relative py-10 px-4  rounded-2xl move-up delay-75" style="--order: 16">

              <div class="py-2 flex justify-center">
                <div class="bg-grey rounded-full p-2 profile-container scale-up delay-200" style="--order:18">
                  <img alt="Logo" class="max-w-max  h-[100px] rounded-full"
                       src="assets/images/user-icon.png"
                       title="Logo">
                </div>
              </div>

              <div class="py-4 px-4" *ngIf="showLogin">
                <form
                  (ngSubmit)="login(form.value)"
                  [formGroup]="form"
                  autocomplete="off"
                  novalidate
                >
                  <div class="block mb-3 move-up" style="--order:4">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Username' | concat | translate }}</mat-label>
                      <input matInput formControlName="username" name="username"
                             placeholder="{{ 'Username' | concat | translate }}" required>
                      <mat-icon class="material-icons-outlined" matSuffix>email</mat-icon>
                      <mat-error>
                                              <span
                                                *ngIf="!form.get('username')?.valid && !form.get('username')?.untouched">
                                                  {{ 'Field is required' | concat | translate }}
                                              </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="block mb-3 move-up" style="--order:5">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Password' | concat | translate }}</mat-label>
                      <input matInput formControlName="password" name="password"
                             placeholder="{{ 'Password' | concat | translate }}" [type]="hide ? 'password' : 'text'"/>
                      <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                              [attr.aria-label]="'Hide'"
                              [attr.aria-pressed]="hide">
                        <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
                        </mat-icon>
                      </button>
                      <mat-error>
                                              <span
                                                *ngIf="!form.get('password')?.valid && !form.get('password')?.untouched">
                                                  {{ 'Field is required' | concat | translate }}
                                              </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="block mb-5 move-up text-end" style="--order:5">
                    <span class="inline-flex items-center cursor-pointer hover:text-accent"
                          (click)="showLogin=!showLogin">
                      <mat-icon class="mx-2">help_outlined</mat-icon> Forgot Password?
                    </span>
                  </div>

                  <div class="flex gap-2 items-center move-up" style="--order:5">
                    <button
                      class="flex gap-5 justify-center items-center !h-10 rounded-lg !bg-accent text-white"
                      type="button"
                      [routerLink]="['','register']">
                      <span class="block py-2 px-7 text-md">{{ 'Register' | concat | translate }} </span>
                    </button>
                    <button
                      [ngClass]="form?.valid ?' !bg-primary text-white':'!bg-grey/50 text-gray-500'"
                      class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                      type="submit"
                      [disabled]="!form.valid || loading">
                      <span class="block p-2 text-md">{{ 'Login' | concat | translate }} </span>
                    </button>
                    <mat-progress-spinner
                      color="primary" [diameter]="30" mode="indeterminate"
                      *ngIf="loading"
                    ></mat-progress-spinner>
                  </div>
                </form>
              </div>

              <div class="py-4 px-4" *ngIf="!showLogin">
                @if (showOtpForm) {
                  @if (otpVerified) {
                    <form
                      (ngSubmit)="resetPassword(resetForm.value)"
                      [formGroup]="resetForm"
                      autocomplete="off"
                      novalidate
                    >
                      <div class="block mb-3 pb-3">
                        <div class="bg-primary-50 rounded-xl p-4 text-center">
                          {{ 'Reset Password description and password policy' | concat | translate }}
                        </div>
                      </div>

                      <div class="block mb-3">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'New Password' | concat | translate }}</mat-label>
                          <input [type]="hide ? 'password' : 'text'" formControlName="password" matInput
                                 name="password"
                                 placeholder="{{ 'New Password' | concat | translate }}"/>
                          <button (click)="hide = !hide" [attr.aria-label]="'Hide'" [attr.aria-pressed]="hide"
                                  mat-icon-button matSuffix
                                  type="button">
                            <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                          </button>
                          <mat-error>
                            <span
                              *ngIf="!resetForm.get('password')?.valid && !resetForm.get('password')?.untouched">
                                {{ 'Password must match creteria defined' | concat | translate }}
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="block mb-3">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Confirm Password' | concat | translate }}</mat-label>
                          <input [type]="hide ? 'password' : 'text'" formControlName="confirmPassword" matInput
                                 name="confirmPassword"
                                 placeholder="{{ 'Confirm Password' | concat | translate }}"/>
                          <button (click)="hide = !hide" [attr.aria-label]="'Hide'" [attr.aria-pressed]="hide"
                                  mat-icon-button matSuffix
                                  type="button">
                            <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                          </button>
                          <mat-error>
                            <span
                              *ngIf="!resetForm.get('confirmPassword')?.valid && !resetForm.get('confirmPassword')?.untouched">
                                {{ 'Field is required' | concat | translate }}
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div
                        *ngIf="
                          resetForm.get('password')?.value && resetForm.get('confirmPassword')?.value &&
                          resetForm.get('password')?.value != resetForm.get('confirmPassword')?.value
                        "
                        class="block mb-3 pb-3"
                      >
                        <div class="bg-red-100 rounded-xl text-red-700 p-4">
                          {{ 'The Password and Confirm Password must be the same' | concat | translate }}
                        </div>
                      </div>

                      <div class="flex gap-2 items-center move-up" style="--order:6">
                        <button
                          [ngClass]="resetForm?.valid ?' !bg-primary text-white':'!bg-grey/50 text-gray-500'"
                          class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                          type="submit"
                          [disabled]="!resetForm.valid || loading">
                          <span class="block p-2 text-md">{{ 'Change Password' | concat | translate }} </span>
                        </button>
                        <mat-progress-spinner
                          color="primary" [diameter]="30" mode="indeterminate"
                          *ngIf="loading"
                        ></mat-progress-spinner>
                      </div>
                    </form>
                  } @else {
                    <form
                      (submit)="verifyOtp(otpForm.value)"
                      [formGroup]="otpForm"
                      autocomplete="off"
                      novalidate
                    >
                      <div class="block py-3 mb-4 text-center">
                        <div class="block bg-primary-50 rounded-lg p-4">
                                <span class="block pb-2">
                                    {{ 'Please enter the One Time Password message' | concat | translate }}
                                </span>
                          <span class="text-2xl font-medium text-red-600" *ngIf="otpTimeRemain > 0; else resendOtpView">
                                    {{ getMinutes(otpTimeRemain) }} : {{ getSeconds(otpTimeRemain) }}
                                </span>
                          <ng-template #resendOtpView>
                                    <span class="block pb-1">
                                        <button
                                          mat-raised-button
                                          color="warn"
                                          (click)="resendOtp()"
                                          type="button"
                                        >
                                            <span class="uppercase"> {{ 'Resend OTP' | concat | translate }} </span>
                                        </button>
                                    </span>
                          </ng-template>
                        </div>
                      </div>

                      <div class="block py-2 max-w-80 mx-auto">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Enter OTP' | concat | translate }}</mat-label>
                          <input
                            matInput formControlName="otp" name="otp"
                            placeholder="{{ 'Enter OTP' | concat | translate }}" required
                            class="text-center !text-4xl" [showMaskTyped]="true" mask="0 0 0 0 0 0"
                          >
                          <mat-error>
                                    <span *ngIf="!otpForm.get('otp')?.valid && !otpForm.get('otp')?.untouched">
                                        {{ 'Field is required' | concat | translate }}
                                    </span>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex gap-2 items-center max-w-96 mx-auto">
                        <button
                          [ngClass]="otpForm?.valid ?' !bg-accent text-white':'!bg-grey/50 text-gray-500'"
                          class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                          type="submit"
                          [disabled]="!otpForm.valid || loading">
                          <span class="block p-2 text-md">{{ 'Verify' | concat | translate }} </span>
                        </button>
                        <mat-progress-spinner
                          *ngIf="loading"
                          color="primary" [diameter]="30" mode="indeterminate"
                        ></mat-progress-spinner>
                      </div>
                    </form>
                  }
                } @else {
                  <form
                    (ngSubmit)="forgotPassword(forgotForm.value)"
                    [formGroup]="forgotForm"
                    autocomplete="off"
                    novalidate
                  >
                    <div class="block mb-5 move-up bg-primary-50 rounded-xl text-center p-3" style="--order:4">
                      {{ 'Forgot Passord description' | concat | translate }}
                    </div>

                    <div class="block mb-5 move-up" style="--order:4">
                      <mat-checkbox color="primary" formControlName="usePhone">
                        {{ 'Reset using Phone Number' | concat | translate }}
                      </mat-checkbox>
                    </div>

                    <div class="block mb-3 move-up" style="--order:4" *ngIf="forgotForm?.value?.usePhone === false">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Email Address' | concat | translate }}</mat-label>
                        <input matInput formControlName="email" name="email"
                               placeholder="{{ 'Email Address' | concat | translate }}">
                        <mat-icon class="material-icons-outlined" matSuffix>email</mat-icon>
                        <mat-error>
                          <span
                            *ngIf="!forgotForm.get('email')?.valid && !forgotForm.get('email')?.untouched">
                              {{ 'Field is required' | concat | translate }}
                          </span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="block mb-3 move-up" style="--order:5" *ngIf="forgotForm?.value?.usePhone === true">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Phone Number' | concat | translate }}</mat-label>
                        <input
                          matInput formControlName="phoneNumber" name="phoneNumber"
                          placeholder="{{ 'Phone Number' | concat | translate }}" required
                          [showMaskTyped]="true" [dropSpecialCharacters]="false" prefix="255" mask="000000000"
                        >
                        <mat-error>
                              <span
                                *ngIf="!forgotForm.get('phoneNumber')?.valid && !forgotForm.get('phoneNumber')?.untouched">
                                  {{ 'Field is required' | concat | translate }}
                              </span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="block mb-5 move-up text-end" style="--order:5">
                      <span class="inline-flex items-center cursor-pointer hover:text-accent"
                            (click)="showLogin=!showLogin">
                        <mat-icon class="mx-2">arrow_back</mat-icon> Back to Login
                      </span>
                    </div>

                    <div class="flex gap-2 items-center move-up" style="--order:6">
                      <button
                        [ngClass]="forgotForm?.valid ?' !bg-primary text-white':'!bg-grey/50 text-gray-500'"
                        class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                        type="submit"
                        [disabled]="!forgotForm.valid || loading">
                        <span class="block p-2 text-md">{{ 'Reset Password' | concat | translate }} </span>
                      </button>
                      <mat-progress-spinner
                        color="primary" [diameter]="30" mode="indeterminate"
                        *ngIf="loading"
                      ></mat-progress-spinner>
                    </div>
                  </form>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
